export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9531.8f8390d4.jpg";